/** @description 설정 화면으로 이동하는 훅 */
export const useMoveToSettings = () => {
  const handleMoveToSettings = ({ type }: { type: 'NOTIFICATION' | 'WIFI' | null }) => {
    if (window?.JSBridge) {
      window.JSBridge.moveToSettings(type);
    }

    if (window?.webkit) {
      window.webkit.messageHandlers.moveToSettings.postMessage(type);
    }
  };

  return {
    handleMoveToSettings,
  };
};

export default useMoveToSettings;
